export const email_regex =
  /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+[-]+)|([A-Za-z0-9]+[.]+)|([A-Za-z0-9]+[+]+))*[A-Za-z0-9]+@((\w+[-]+)|(\w+[.]))*\w{1,63}[.][a-zA-Z]{2,6}$/;
export const password_regex =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/;

export const youtube_url_regex =
  /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
